<template>
  <el-cascader
      size="mini"
      :clearable="true"
      style="width: 100%;"
      v-model="currentVal"
      :options="dataList"
      :props="options"></el-cascader>
</template>

<script>
export default {
  name: 'index',
  data () {
    return {
      dataList: [],
      options: {
        expandTrigger: 'hover',
        value: 'id',
        label: 'name',
        emitPath: false
      }
    }
  },
  computed: {
    currentVal: {
      get () {
        return this.value
      },
      set (newVal) {
        this.$emit('input', newVal)
      }
    }
  },
  mounted () {
    this.getDataList()
  },
  methods: {
    async getDataList () {
      const { data: res } = await this.$http.get(`/trade/technology/list`)
      if (res.code !== 0) {
        return this.$message.error(res.msg)
      }
      if(res.data){
        res.data.forEach(p=>{
          if(!p.children||p.children.length===0){
            p.children=null
            return
          }
          p.children.forEach(c=>{
            if(!c.children||c.children.length===0){
              c.children=null
              return
            }
          })
        })
      }
      this.dataList = res.data
    }
  }
}
</script>

<style scoped>

</style>
